import script from "./SendCardConfirmDialog.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SendCardConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SendCardConfirmDialog.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SendCardConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SendCardConfirmDialog.vue.scss?vue&type=style&index=0&id=5c911752&lang=scss!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SendCardConfirmDialog.vue?vue&type=style&index=0&id=5c911752&lang=scss"

const __exports__ = script;

export default __exports__